<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useRouter } from 'vue-router';
import BasePaywallModal from 'dashboard/routes/dashboard/settings/components/BasePaywallModal.vue';
import CustomRoleListItem from './CustomRoleTableBody.vue';
import { useI18n } from 'vue-i18n';

const dummyCustomRolesData = [
  {
    name: 'All Permissions',
    description: 'All permissions',
    permissions: [
      'conversations.manage',
      'conversations.view_participating',
      'conversations.view_unassigned',
      'contacts.manage',
      'reports.overview.view',
      'help_center.manage',
    ],
  },
  {
    name: 'Conversation Permissions',
    description: 'Conversation permissions',
    permissions: [
      'conversations.manage',
      'conversations.view_participating',
      'conversations.view_unassigned',
    ],
  },
  {
    name: 'Contact Permissions',
    description: 'Contact permissions',
    permissions: ['contacts.manage'],
  },
  {
    name: 'Report Permissions',
    description: 'Report permissions',
    permissions: ['reports.overview.view'],
  },
];

const router = useRouter();

const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');

const currentUser = useMapGetter('getCurrentUser');
const currentAccountId = useMapGetter('getCurrentAccountId');

const isSuperAdmin = computed(() => {
  return currentUser.value.type === 'SuperAdmin';
});
const i18nKey = computed(() =>
  isOnChatwootCloud.value ? 'PAYWALL' : 'ENTERPRISE_PAYWALL'
);

const goToBillingSettings = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: currentAccountId.value },
  });
};

const { t } = useI18n();
const tableHeaders = computed(() => {
  return [
    t('CUSTOM_ROLE.LIST.TABLE_HEADER.NAME'),
    t('CUSTOM_ROLE.LIST.TABLE_HEADER.DESCRIPTION'),
    t('CUSTOM_ROLE.LIST.TABLE_HEADER.PERMISSIONS'),
    t('CUSTOM_ROLE.LIST.TABLE_HEADER.ACTIONS'),
  ];
});
</script>

<template>
  <div class="w-full min-h-[12rem] relative">
    <div class="w-full space-y-3 text-sm overflow-x-auto">
      <table class="min-w-full">
        <thead class="opacity-30 dark:opacity-30">
          <tr>
            <th
              v-for="thHeader in tableHeaders"
              :key="thHeader"
              class="py-4 ltr:pr-4 rtl:pl-4 text-start text-heading-3 text-n-slate-12"
            >
              <span class="mb-0">
                {{ thHeader }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="opacity-25 dark:opacity-20">
          <CustomRoleListItem :roles="dummyCustomRolesData" :loading="{}" />
        </tbody>
      </table>
    </div>
    <div
      class="absolute inset-0 flex flex-col items-center justify-center w-full h-full bg-gradient-to-t from-white dark:from-slate-900 to-transparent"
    >
      <BasePaywallModal
        feature-prefix="CUSTOM_ROLE"
        :i18n-key="i18nKey"
        :is-on-chatwoot-cloud="isOnChatwootCloud"
        :is-super-admin="isSuperAdmin"
        @upgrade="goToBillingSettings"
      />
    </div>
  </div>
</template>
